<cdx-slotted-modal size="medium" (close)="onClose()" [footerSlotFlexDirectionOverRide]="modalFooterButtonDirection">
	<div modal-content>
		<cdx-svg-icon name="alert" fill="warning" size="medium"></cdx-svg-icon>

		<p>
			<span><b>Your selected store is</b></span>
			<span class="selectedStore">{{ selectedStoreName$ | async }}</span>
		</p>
		<p>
			<span>
				The price and stock availability of the item may change, if your selected Woolworths is different to the store
				identified by Google.
			</span>
			<span>
				Do you want to change to the <b>{{ mhlsPickupStoreName }}</b> store?
			</span>
		</p>
	</div>
	<button modal-footer-primary cdxButton class="changeStores" (click)="onChangePickupStore()">Yes, change stores</button>
	<button modal-footer-secondary cdxButton class="keepStore" fillStyle="link" (click)="onKeepStore()">
		No, keep shopping from my store
	</button>
</cdx-slotted-modal>
